export enum COLUMN_TYPE {
  VEHICLE = "vehicle",
  VEHICLE_DETAIL = "vehicle_detail",
  VEHICLE_KM = "vehicle_km",
  VEHICLE_TIRES = "vehicle_tires",
  TEXT = "text",
  TEXT_BOLD = "text_bold",
  TEXT_ICON = "text_icon",
  CHIP = "chip",
  CHIP_CLICK = "chip-click",
  ACTION = "action",
  TOGGLE = "toggle",
  PROGRESS_BAR = "progress_bar",
  ICON = "icon",
  CHECKBOX = "checkbox",
  BUTTON = "button",
  ACTION_ICON = "action_icon",
  ACTION_ICON2 = "action_icon2"

}

export enum PAGE_ENUM {
  CREDIT_CARD_SERVICE = "credit-card-service",
  ONLINE_PAYMENT = "online-payment",
  APPOINTMENTS = "appointments",
  REFUELS = "refuels",
  YOUR_COLLABORATORS = "your-collaborators",
  ARCHIVE_DOCUMENT = "archive-document",
  INVOICES = "invoices",
  INVOICES_RECEIPT = "invoices-receipt",
  CONTRACTS = "contracts",
  CONTRACTS_MODIFICATION = "contracts_modification",
  CONTRACTUAL_MODIFICATION = "contractual-modification",
  EXTENSION_DEADLINE = "extension-deadline",
  SERVICE_MODIFICATION = "service-modification",
  MAINTENANCE = "maintenance",
  MAINTENANCE_POSTE = "maintenance-poste",
  MAINTENANCE_HISTORY = "maintenance-history",
  MAINTENANCE_PLAN = "maintenance-plan",
  CAR_SHARING = "car-sharing",
  EX_DRIVERS = "ex-drivers",
  DRIVER_ASSIGN = "drive-assign",
  NOT_REGISTERED = "not-registered",
  INVITED = "invited",
  INVITE_NEW_DRIVERS = "invite-new-drivers",
  REGISTERED = "registered",
  USERS_WAITING = "users-waiting",
  ASSOCIATED_VEHICLES = "associated_vehicles",
  VEHICLE_HISTORY = "vehicle-history",
  VEHICLES = "vehicles",
  VEHICLE_ASSIGNATION = "vehicle-assignation",
  ORDERS = "orders",
  FINES_POST_94 = "fines-post-94",
  HISTORY_REFUELS = "history-refuels",
  SANITATION = "sanitation",
  DELEGATION = "delegation",
  FAQ = "faq",
  TIRES = "tires",
  TIRES_VEHICLE_CHOICE = "tires-vehicle-choice",
  EARLY_RETURN = "early-return",
}
export interface Column {
  label: string;
  order: number;
  id: string;
  orderable: boolean;
  type: COLUMN_TYPE;
  custom?: object;
  width: number;
}
